import {useEffect, useRef} from "react";

export function useTraceUpdate(props) {
  const prev = useRef(props);
  useEffect(() => {
    const changedProps = Object.entries(props).reduce((ps, [k, v]) => {
      if (prev.current[k] !== v) {
        ps[k] = [prev.current[k], v];
      }
      return ps;
    }, {});
    if (Object.keys(changedProps).length > 0) {
      console.log('Changed props:', changedProps);
    }
    prev.current = props;
  });
}

export const getChaptersFromLayout = (layout) => {
  const chapters = [];
  const newChapters = [];

  layout.forEach((section, index) => {
    const {chapterName, chapter} = section;
    if (chapter && !chapters.includes(chapterName)) {
      chapters.push(chapterName);
      newChapters.push({
        chapterName,
        startingAt: index,
        subchapters: [{
          ...section,
          absId: index,
        }]
      });
    } else {
      const lastChapter = newChapters[newChapters.length - 1];
      lastChapter.subchapters.push({
        ...section,
        absId: index,
      });
      newChapters[newChapters.length - 1] = lastChapter;
    }
  });

  return newChapters;
};

export const getStepperChaptersFromLayout = (layout, current) => {
  const chapters = [];
  layout.forEach((item, index) => {
    const {chapter} = item;
    if (chapter) {
      chapters.push({
        title: item.title,
        chapterName: item.chapterName,
        startingAt: index,
        children: [
          {
            chapter: true,
            visited: current >= index,
            title: item.title,
          }
        ],
      });
    }
    const title = chapters[chapters.length - 1].title;
    const chapterName = chapters[chapters.length - 1].chapterName;
    const children = chapters[chapters.length - 1].children;
    const startingAt = chapters[chapters.length - 1].startingAt;
    if (index !== layout.length - 1) {
      children.push({
        ...item,
        visited: current >= index,
        isCurrent: current === index,
        chapter: false,
      })
    }
    chapters[chapters.length - 1] = {
      title,
      chapterName,
      startingAt,
      children
    };
  });
  return chapters;
};
